/** Independence Day banner: show through 14 August, revert from 15 August. */
export const isAugust14LandingBannerActive = (date = new Date()) => {
  const month = date.getMonth();
  const day = date.getDate();
  return month === 7 && day <= 31;
};
